import React, { useRef, useState, useEffect, useContext } from "react";
import debounce from "lodash.debounce";
import { Item, Menu, Label, Field, Dropdown, Autocomplete } from "@zendeskgarden/react-dropdowns";
import { Row, Col } from "@zendeskgarden/react-grid";
import "./style/dropdownSku.css";
import AppContext from "../../context/AppContext";

const DropDownSKU = (props) => {
  // const [selectedItem, setSelectedItem] = useState(props.options[0]);
  const [inputValue, setInputValue] = useState("");
  const { setProductID, productID } = useContext(AppContext);

  return (
    <Row justifyContent="left">
      <Col sm={12}>
        <Dropdown
          inputValue={inputValue}
          selectedItem={props.selectedItem}
          onSelect={props.onSelect}
          onInputValueChange={(value) => {
            setInputValue(value);
            props.onChange(value);
          }}
          downshiftProps={{ defaultHighlightedIndex: 0 }}
        >
          <Field>
            <Autocomplete className="warranty-c-dist-autocomplete">{props.selectedItem}</Autocomplete>
          </Field>
          <Menu className="warranty-c-dist-menu">
            {props.options?.length ? (
              props.options.map((option) => (
                <Item
                  key={option.reference}
                  value={option.reference}
                  onClick={() => {
                    console.log({ option });
                    setProductID(option.id);
                  }}
                >
                  <span>{option.reference}</span>
                </Item>
              ))
            ) : (
              <Item disabled>No matches found</Item>
            )}
          </Menu>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default DropDownSKU;
